module.exports = __webpack_public_path__ + "static/media/logo-black.bb2e4c23.svg";